module.exports = __webpack_public_path__ + "img/mutual-respect.8504ff2c.png";